// function initLivechatTrigger() {
//   const chatLinks = document.querySelectorAll('.open_livechat');
//   if (!chatLinks.length) return;

//   chatLinks.forEach(link => {
//     link.addEventListener('click', event => {
//       event.preventDefault();
//       const shopifyChat = document.getElementById('ShopifyChat');
//       if (shopifyChat && shopifyChat.shadowRoot) {
//         const chatToggleButton = shopifyChat.shadowRoot.querySelector('button.chat-toggle');
//         if (chatToggleButton) {
//           chatToggleButton.click();
//         } else {
//           console.warn('Chat toggle button not found within ShopifyChat shadow DOM.');
//         }
//       } else {
//         console.warn('ShopifyChat element or its shadowRoot not found.');
//       }
//     });
//   });
// }



function initLivechatTrigger() {
  if (window.__MM_LIVECHAT_TRIGGER_V2) return;
  window.__MM_LIVECHAT_TRIGGER_V2 = true;

  const TRIGGER_SELECTOR = '.open_livechat';
  const CHAT_SELECTOR = '#ShopifyChat';
  const MAX_ATTEMPTS = 30;
  const RETRY_DELAY = 200;

  function getChatHost() {
    return document.querySelector(CHAT_SELECTOR);
  }

  function getChatToggleButton() {
    const chatHost = getChatHost();

    if (!chatHost || !chatHost.shadowRoot) return null;

    return (
      chatHost.shadowRoot.querySelector('button[data-spec="toggle-button"]') ||
      chatHost.shadowRoot.querySelector('button.chat-toggle')
    );
  }

  function isChatOpen() {
    const chatHost = getChatHost();

    if (!chatHost) return false;

    return (
      chatHost.getAttribute('is-open') === 'true' ||
      chatHost.hasAttribute('open') ||
      getChatToggleButton()?.getAttribute('aria-expanded') === 'true'
    );
  }

  function openLivechat() {
    let attempts = 0;

    const timer = setInterval(function () {
      attempts += 1;

      const toggleButton = getChatToggleButton();

      if (!toggleButton) {
        if (attempts >= MAX_ATTEMPTS) {
          clearInterval(timer);
          console.warn('[LiveChat] Shopify chat toggle button not found.');
        }
        return;
      }

      if (isChatOpen()) {
        clearInterval(timer);
        console.log('[LiveChat] Chat already open.');
        return;
      }

      toggleButton.click();

      setTimeout(function () {
        if (isChatOpen()) {
          console.log('[LiveChat] Chat opened.');
        } else {
          console.warn('[LiveChat] Toggle clicked, but chat state is still closed.');
        }
      }, 300);

      clearInterval(timer);
    }, RETRY_DELAY);
  }

  function closeLivechat() {
    const toggleButton = getChatToggleButton();

    if (!toggleButton) return;

    if (isChatOpen()) {
      toggleButton.click();
      console.log('[LiveChat] Chat closed.');
    }
  }

  function toggleLivechat() {
    if (isChatOpen()) {
      closeLivechat();
    } else {
      openLivechat();
    }
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    toggleLivechat();
  }, true);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLivechatTrigger);
} else {
  initLivechatTrigger();
}

// Add more functions in this to initialize them on interaction
function initializeAll() {
  initLivechatTrigger();
//   initLivechatTrigger2();  example!!
}

const events = ['scroll', 'touchstart', 'keydown', 'click'];

const runOnce = () => {
  initializeAll();
  events.forEach(evt => window.removeEventListener(evt, runOnce));
};

events.forEach(evt => {
  window.addEventListener(evt, runOnce, { once: true, passive: true });
});


// For empty filter rempover


document.querySelectorAll('accordion-disclosure').forEach(wrapper => {

  const groups = wrapper.querySelectorAll('.accordion__disclosure.group.collection-filter-group');

  const hasContent = Array.from(groups).some(group => {
    const inner = group.querySelectorAll('.collection-filters__filter-group');
    return Array.from(inner).some(el => el.textContent.trim().length > 0);
  });

  // if (!hasContent) {
  //   wrapper.style.display = 'none';
  // }

});